import MONSTRO_2 from "url:../sprites/gelado.png";
import SOM_10 from "url:../sfx/weeon.m4a";

export default {
  attack: 2,
  life: 6,
  speed: 4,
  agility: 4,
  armor: 1,
  image: MONSTRO_2,
  sound: SOM_10,
};
